import { AiOutlineCheck } from "react-icons/ai";
function Yes() {
  return <AiOutlineCheck className="text-hgGreen-900 text-xl" />;
}

export default Yes;
